import React, { FC } from 'react'

import ConnectedEmployeeBalancesPerPeriod from '../../connectors/ConnectedEmployeeBalancesPerPeriod/ConnectedEmployeeBalancesPerPeriod'


const LoketHoursPerPeriodPage: FC = () => (
    <ConnectedEmployeeBalancesPerPeriod />
)

export default LoketHoursPerPeriodPage
